import { IconLibrary } from '@product-framework/index';
import { FormattedMessage } from 'react-intl';

const DispatchCalendarHelper = {
  getMainActionButtonText({ isRescheduleFlow, isAssign, isReAssign }) {
    if (isRescheduleFlow) {
      return {
        id: 'RESCHEDULE',
        defaultMessage: 'Reschedule',
      };
    }
    if (isAssign) {
      return {
        id: 'ASSIGN',
        defaultMessage: 'Assign',
      };
    }
    if (isReAssign) {
      return {
        id: 'REASSIGN',
        defaultMessage: 'Reassign',
      };
    }
    return {
      id: 'DISPATCH',
      defaultMessage: 'Dispatch',
    };
  },
  getDialogTitle({ isRescheduleFlow, isAssign, isReAssign }) {
    if (isRescheduleFlow) {
      return {
        id: 'RESCHEDULE_JOB',
        defaultMessage: 'Reschedule Job',
      };
    }
    if (isAssign) {
      return {
        id: 'ASSIGN_JOB',
        defaultMessage: 'Assign Job',
      };
    }
    if (isReAssign) {
      return {
        id: 'REASSIGN_JOB',
        defaultMessage: 'Reassign Job',
      };
    }
    return {
      id: 'DISPATCH_JOB',
      defaultMessage: 'Dispatch Job',
    };
  },
  getDialogIcon({ isRescheduleFlow, isAssign, isReAssign }) {
    if (isRescheduleFlow) {
      return <IconLibrary.Reschedule />;
    }
    if (isAssign) {
      return <IconLibrary.AssignServiceJob />;
    }
    if (isReAssign) {
      return <IconLibrary.AssignServiceJob />;
    }
    return <IconLibrary.Dispatch />;
  },
  getSaveInProgressText({ isRescheduleFlow, isAssign, isReAssign }) {
    if (isRescheduleFlow) {
      return (
        <FormattedMessage
          id="JOB_RESCHEDULE_IN_PROGRESS"
          defaultMessage="Job reschedule in progress"
        />
      );
    }
    if (isAssign) {
      return (
        <FormattedMessage
          id="JOB_ASSIGN_IN_PROGRESS"
          defaultMessage="Job assign in progress"
        />
      );
    }
    if (isReAssign) {
      return (
        <FormattedMessage
          id="JOB_REASSIGN_IN_PROGRESS"
          defaultMessage="Job reassign in progress"
        />
      );
    }
    return (
      <FormattedMessage
        id="JOB_DISPATCH_IN_PROGRESS"
        defaultMessage="Job dispatch in progress"
      />
    );
  },
  getSaveDialogQuestion({
    isRescheduleFlow,
    isAssign,
    isReAssign,
    formattedMessageParams,
  }) {
    if (isRescheduleFlow) {
      return (
        <FormattedMessage
          id="DO_YOU_WANT_TO_RESCHEDULE_THE_JOB_FOR_DATED_TIMESLOT_TIME_SLOT"
          defaultMessage="Do you want to reschedule the job for {dated} {timeslot} time slot?"
          values={formattedMessageParams}
        />
      );
    }
    if (isAssign) {
      return (
        <FormattedMessage
          id="DO_YOU_WANT_TO_ASSIGN_THE_JOB_FOR_DATED_TIMESLOT_TIME_SLOT"
          defaultMessage="Do you want to assign the job for {dated} {timeslot} time slot?"
          values={formattedMessageParams}
        />
      );
    }
    if (isReAssign) {
      return (
        <FormattedMessage
          id="DO_YOU_WANT_TO_REASSIGN_THE_JOB_FOR_DATED_TIMESLOT_TIME_SLOT"
          defaultMessage="Do you want to reassign the job for {dated} {timeslot} time slot?"
          values={formattedMessageParams}
        />
      );
    }
    return (
      <FormattedMessage
        id="DO_YOU_WANT_TO_DISPATCH_THE_JOB_FOR_DATED_TIMESLOT_TIME_SLOT"
        defaultMessage="Do you want to dispatch the job for {dated} {timeslot} time slot?"
        values={formattedMessageParams}
      />
    );
  },
  getSaveSuccessDialogMessage({ isRescheduleFlow, isAssign, isReAssign }) {
    if (isRescheduleFlow) {
      return (
        <FormattedMessage
          id="JOB_WAS_RESCHEDULED_SUCCESSFULLY"
          defaultMessage="Job was rescheduled successfully"
        />
      );
    }
    if (isAssign) {
      return (
        <FormattedMessage
          id="JOB_WAS_ASSIGNED_SUCCESSFULLY"
          defaultMessage="Job was assigned successfully"
        />
      );
    }
    if (isReAssign) {
      return (
        <FormattedMessage
          id="JOB_WAS_REASSIGNED_SUCCESSFULLY"
          defaultMessage="Job was reassigned successfully"
        />
      );
    }
    return (
      <FormattedMessage
        id="JOB_WAS_DISPATCHED_SUCCESSFULLY"
        defaultMessage="Job was dispatched successfully"
      />
    );
  },
};

export default DispatchCalendarHelper;
